export enum ROUTES {
  CBR_STUDIES_LIST = 'cbr-studies',
  CUSTOMER_STUDIES_LIST = 'customers',
  DISPATCHED_STUDIES_LIST = 'dispatches',
  ERROR = 'error',
  LOGIN = 'ingreso',
  STUDY = 'study',
  STUDY__FORM = 'form',
  STUDY__INFO = 'info',
  STUDY__HISTORY = 'history',
}

export const AUTH_HOME_ROUTE = ROUTES.DISPATCHED_STUDIES_LIST;
export const UNAUTH_HOME_ROUTE = ROUTES.LOGIN;
